import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="w-full bg-sage text-cream py-20 px-6" data-id="element-127">
      <div className="max-w-3xl mx-auto text-center" data-id="element-128">
        <FadeIn data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-cream" data-id="element-130">
            Lo que cambia en 7 días
          </h2>

          <div className="prose prose-lg md:prose-xl text-cream/90 mx-auto" data-id="element-131">
            <p className="mb-6" data-id="element-132">
              Pasarás de dudar de cada frase y sentir un "ruido" constante en tu
              cabeza, a recuperar esa sensación de nitidez y mando sobre tu
              intelecto.
            </p>
            <p className="font-serif text-2xl md:text-3xl text-gold mb-6 italic" data-id="element-133">
              No es magia, es bioquímica aplicada a la mujer moderna.
            </p>
            <p className="font-bold text-xl" data-id="element-134">
              Dejarás de sobrevivir al día y empezarás a dominarlo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}